import { NotificationProps } from "providers";
import { IStores } from "stores";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { ActionModal } from "./ActionModal";
import { NominalAccountsStore } from "stores/NominalAccountsStore";

import { ReactComponent as CancelIcon } from "images/removeIcon.svg";
import { ReactComponent as CheckIcon } from "images/check.svg";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right.svg";
import { requestWithNotify } from "utils";
import { NOMINAL_ACCOUNT_REQUESTS_DELAY } from "constants/nominalAccount";

export enum ACTION_TYPE_ENUM {
  START_PROCESSING = "START_PROCESSING",
  CANCEL = "CANCEL",
  PROCESSING = "PROCESSING",
}

export interface IActionHandlerParams {
  bidId: string;
  openNotification: (props: NotificationProps) => void;
  stores: Pick<IStores, "nominalAccounts" | "actionModals" | "rubWithdrawalRequests">;
}

const startProcessing = async (params: IActionHandlerParams) => {
  const { bidId, openNotification, stores } = params;
  const { nominalAccounts } = stores;

  const res = await requestWithNotify({
    fetchFn: () => nominalAccounts.fetchStartProcessingRubWithdrawal(bidId),
    openNotification,
    successMsg: "Заявка на вывод успешно взята в работу",
    errorMsg: "Ошибка при запуске обработки. Попробуйте позже",
  });

  if (res.result) {
    requestWithNotify({
      fetchFn: () => nominalAccounts.fetchAllBalances({ rubOperationsFetch: false }),
      openNotification,
      delay: NOMINAL_ACCOUNT_REQUESTS_DELAY,
      successMsg: "Балансы обновлены",
    });
  }
};

const complete = (params: IActionHandlerParams) => {
  params.stores.actionModals.open(() => <ActionModal bidId={params.bidId} actionType={ACTION_TYPE_ENUM.PROCESSING} />, {
    width: "600px",
    title: "Введите номер платежного поручения",
    onClose: () => {
      params.stores.actionModals.closeAll();
    },
  });
};

const cancel = (params: IActionHandlerParams) => {
  params.stores.actionModals.open(() => <ActionModal bidId={params.bidId} actionType={ACTION_TYPE_ENUM.CANCEL} />, {
    width: "600px",
    title: "Подтвердите отмену заявки на вывод",
    onClose: () => {
      params.stores.actionModals.closeAll();
    },
  });
};

export const actions = {
  handlers: {
    [ACTION_TYPE_ENUM.START_PROCESSING]: startProcessing,
    [ACTION_TYPE_ENUM.PROCESSING]: complete,
    [ACTION_TYPE_ENUM.CANCEL]: cancel,
  },
  statuses: {
    [ACTION_TYPE_ENUM.START_PROCESSING]: (nominalAccounts: NominalAccountsStore) =>
      nominalAccounts.startProcessingStatuses,
    [ACTION_TYPE_ENUM.PROCESSING]: (nominalAccounts: NominalAccountsStore) => nominalAccounts.completeStatuses,
    [ACTION_TYPE_ENUM.CANCEL]: (nominalAccounts: NominalAccountsStore) => nominalAccounts.cancelStatuses,
  },
  btnTitles: {
    [ACTION_TYPE_ENUM.START_PROCESSING]: <ArrowRightIcon />,
    [ACTION_TYPE_ENUM.PROCESSING]: <CheckIcon />,
    [ACTION_TYPE_ENUM.CANCEL]: <CancelIcon />,
  },
};
